import {
  GET_CLIENT_REQUESTING,
  GET_CLIENT_SUCCESS,
  GET_CLIENT_ERROR,
  SET_CLIENT,
} from "./constants";
import { LOGOUT } from "../login/constants";
import { IClientReducer } from "./types";

const initialState: IClientReducer = {
  logo: "",
  name: "",
  requesting: false,
  _id: "",
  defaultUserSkills: [],
  hasAvatars: true,
  hasMbti: true,
  hasCustomOnboarding: false,
  isCoachingAccount: false,
  isPhoneNumberRequired: false,
};

const reducer = function signupReducer(
  state: IClientReducer = initialState,
  action,
): IClientReducer {
  switch (action.type) {
    case GET_CLIENT_REQUESTING:
      return {
        ...state,
        requesting: true,
      };

    case GET_CLIENT_SUCCESS:
      return {
        ...state,
        ...action.payload,
        requesting: false,
      };

    case GET_CLIENT_ERROR:
      return {
        ...state,
        requesting: false,
      };

    case SET_CLIENT:
      return {
        ...state,
        ...action.payload,
      };

    case LOGOUT:
      return initialState;

    default:
      return state;
  }
};

export default reducer;
